var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LoadingPage", attrs: { id: "LoadingPage" } },
    [
      _c(
        "VueLoading",
        {
          attrs: {
            active: _vm.isLoading || _vm.setting.isLoading,
            loader: _vm.setting.loader,
            "is-full-page": _vm.setting.fullPage,
            color: _vm.setting.color,
            "background-color": _vm.setting.bgColor,
            opacity: _vm.setting.bgOpacity,
            "lock-scroll": _vm.setting.lockScroll,
            "z-index": _vm.setting.zIndex,
          },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.isLoading || _vm.setting, "isLoading", $event)
            },
          },
        },
        [
          _c("template", { slot: "before" }),
          _c("template", { slot: "default" }, [
            _vm.isCustomizeStyle
              ? _c("div", { staticClass: "loadingio-spinner-rolling-wrap" }, [
                  _c("div", { staticClass: "animate" }, [_c("div")]),
                ])
              : _vm._e(),
          ]),
          _c("template", { slot: "after" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }